import styled from 'styled-components'

export default styled.img`
	width: 100%;
	border-radius: 3px;
`
